import { DEFAULT_LANGUAGE_TYPE, SHOW_TRANSLATION_KEY } from '../types/language';

/**
 * Resolves the locale to use for number formatting from the current language.
 *
 * Falls back to {@link DEFAULT_LANGUAGE_TYPE} when no language is set yet
 * (e.g. during bootstrap, before `TranslateService.use()` ran) and for the
 * dev-only {@link SHOW_TRANSLATION_KEY} language, which is not a valid locale
 * and would make `Intl.NumberFormat` and Angular's number pipes throw.
 */
export function resolveFormattingLocale(
  lang: string | null | undefined,
): string {
  return lang && lang !== SHOW_TRANSLATION_KEY ? lang : DEFAULT_LANGUAGE_TYPE;
}
